var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlower5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 505 487",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M387.974 138.314C356.246 149.943 327.827 169.122 305.171 194.193C322.015 164.841 331.382 131.797 332.448 97.9723C332.448 27.3517 253 0.868896 253 0.868896C253 0.868896 173.552 27.3517 173.552 97.9723C174.618 131.797 183.985 164.841 200.829 194.193C178.133 169.25 149.717 150.195 118.026 138.668C50.8482 116.51 1.14893 183.865 1.14893 183.865C1.14893 183.865 1.76685 267.639 68.9448 289.796C101.421 299.175 135.702 300.448 168.785 293.503C137.889 307.328 110.875 328.551 90.131 355.297C48.6413 412.411 97.3696 480.56 97.3696 480.56C97.3696 480.56 176.818 505.807 218.661 448.692C237.8 420.43 249.601 387.847 253 353.884C256.499 387.633 268.296 419.992 287.339 448.074C328.829 505.189 408.63 479.942 408.63 479.942C408.63 479.942 457.359 411.793 415.869 354.679C395.171 327.995 368.259 306.781 337.48 292.885C370.474 299.833 404.67 298.56 437.055 289.178C504.233 267.374 504.851 183.247 504.851 183.247C504.851 183.247 455.152 116.51 387.974 138.314Z",
    fill: "#F0C419"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M332.448 97.9723C332.448 153.321 300.316 210.965 264.829 252.632C259.151 247.494 250.808 246.603 244.172 250.425C231.689 230.245 217.165 211.403 200.829 194.193C202.33 194.193 173.552 151.732 173.552 97.9723C173.552 27.3517 253 0.868896 253 0.868896C253 0.868896 332.448 27.3517 332.448 97.9723Z",
    fill: "#9443AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M332.448 97.9723C332.448 153.321 300.316 210.965 264.829 252.632C259.151 247.494 250.808 246.603 244.172 250.425C231.689 230.245 217.165 211.403 200.829 194.193C202.33 194.193 173.552 151.732 173.552 97.9723C173.552 27.3517 253 0.868896 253 0.868896C253 0.868896 332.448 27.3517 332.448 97.9723Z",
    fill: "url(#paint0_linear_1692_139488)",
    fillOpacity: 0.48
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M253 256.869C248.125 256.869 244.172 252.917 244.172 248.041V142.11C244.172 137.235 248.125 133.283 253 133.283C257.875 133.283 261.828 137.235 261.828 142.11V248.041C261.828 252.917 257.875 256.869 253 256.869Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M235.345 269.404C212.332 274.931 189.964 282.86 168.608 293.062C135.467 299.958 101.148 298.716 68.5918 289.443C1.41383 267.639 0.795898 183.512 0.795898 183.512C0.795898 183.512 50.8483 116.51 118.026 138.314C170.992 155.44 215.13 203.462 244.172 250.425C237.393 254.137 233.816 261.827 235.345 269.404Z",
    fill: "#844EAE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M235.345 269.404C212.332 274.931 189.964 282.86 168.608 293.062C135.467 299.958 101.148 298.716 68.5918 289.443C1.41383 267.639 0.795898 183.512 0.795898 183.512C0.795898 183.512 50.8483 116.51 118.026 138.314C170.992 155.44 215.13 203.462 244.172 250.425C237.393 254.137 233.816 261.827 235.345 269.404Z",
    fill: "url(#paint1_linear_1692_139488)",
    fillOpacity: 0.48
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M236.228 269.051C234.197 269.051 241.877 271.434 132.768 235.859C128.314 234.219 125.954 229.35 127.427 224.837C128.899 220.324 133.677 217.784 138.241 219.087L238.964 251.837C243.08 253.19 245.606 257.33 244.926 261.609C244.246 265.888 240.56 269.041 236.228 269.051Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M253 353.884C249.501 387.633 237.704 419.992 218.661 448.074C177.171 505.189 97.3698 479.942 97.3698 479.942C97.3698 479.942 48.6415 411.793 90.1311 354.679C122.44 310.188 182.379 282.469 235.345 269.404C236.949 276.882 243.185 282.477 250.793 283.263C249.087 306.817 249.827 330.483 253 353.884Z",
    fill: "#A759C0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M253 353.884C249.501 387.633 237.704 419.992 218.661 448.074C177.171 505.189 97.3698 479.942 97.3698 479.942C97.3698 479.942 48.6415 411.793 90.1311 354.679C122.44 310.188 182.379 282.469 235.345 269.404C236.949 276.882 243.185 282.477 250.793 283.263C249.087 306.817 249.827 330.483 253 353.884Z",
    fill: "url(#paint2_linear_1692_139488)",
    fillOpacity: 0.48
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M180.349 374.54C177.085 374.42 174.154 372.507 172.73 369.566C171.306 366.626 171.622 363.141 173.552 360.505L235.345 274.789C237.332 272.329 240.48 271.116 243.604 271.606C246.728 272.097 249.353 274.217 250.489 277.168C251.626 280.118 251.103 283.452 249.116 285.912L187.323 370.921C185.693 373.153 183.112 374.492 180.349 374.54Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M408.63 479.942C408.63 479.942 329.182 505.189 287.339 448.074C254.677 403.142 246.997 337.818 251.146 283.263C258.651 283.913 265.741 279.73 268.801 272.847C290.744 281.896 313.548 288.699 336.862 293.15C367.72 307.037 394.72 328.249 415.516 354.943C457.359 411.793 408.63 479.942 408.63 479.942Z",
    fill: "#844EAE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M408.63 479.942C408.63 479.942 329.182 505.189 287.339 448.074C254.677 403.142 246.997 337.818 251.146 283.263C258.651 283.913 265.741 279.73 268.801 272.847C290.744 281.896 313.548 288.699 336.862 293.15C367.72 307.037 394.72 328.249 415.516 354.943C457.359 411.793 408.63 479.942 408.63 479.942Z",
    fill: "url(#paint3_linear_1692_139488)",
    fillOpacity: 0.48
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M325.651 374.541C322.826 374.548 320.168 373.203 318.501 370.921L256.178 285.206C254.317 282.619 253.977 279.237 255.287 276.333C256.596 273.428 259.355 271.443 262.525 271.124C265.695 270.806 268.794 272.203 270.655 274.789L332.448 360.505C334.378 363.141 334.694 366.627 333.27 369.567C331.846 372.507 328.915 374.42 325.651 374.541Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M504.851 183.865C504.851 183.865 504.233 267.639 437.055 289.796C384.09 307.451 320.178 294.298 269.331 273.2C272.398 266.234 270.654 258.086 265.006 252.985C280.379 234.82 293.839 215.119 305.171 194.193C327.867 169.25 356.283 150.195 387.974 138.668C455.152 116.51 504.851 183.865 504.851 183.865Z",
    fill: "#A759C0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M504.851 183.865C504.851 183.865 504.233 267.639 437.055 289.796C384.09 307.451 320.178 294.298 269.331 273.2C272.398 266.234 270.654 258.086 265.006 252.985C280.379 234.82 293.839 215.119 305.171 194.193C327.867 169.25 356.283 150.195 387.974 138.668C455.152 116.51 504.851 183.865 504.851 183.865Z",
    fill: "url(#paint4_linear_1692_139488)",
    fillOpacity: 0.48
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M269.772 269.051C265.44 269.041 261.754 265.888 261.074 261.609C260.394 257.33 262.92 253.19 267.036 251.837L367.759 219.087C372.323 217.784 377.101 220.324 378.573 224.837C380.046 229.35 377.686 234.219 373.232 235.859C264.034 271.434 271.891 269.051 269.772 269.051Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M280 265.971C280.013 279.077 270.613 290.299 257.708 292.584C244.803 294.869 232.121 287.555 227.635 275.242C223.148 262.928 228.153 249.17 239.503 242.617C247.852 237.797 258.137 237.794 266.489 242.61C274.84 247.426 279.99 256.33 280 265.971Z",
    fill: "#E07DFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1692_139488",
    x1: 299.714,
    y1: 0.582847,
    x2: 221.917,
    y2: 242.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1692_139488",
    x1: 244,
    y1: 216.159,
    x2: 19.128,
    y2: 280.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1692_139488",
    x1: 216,
    y1: 269.159,
    x2: 163.199,
    y2: 485.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1692_139488",
    x1: 394.912,
    y1: 272.605,
    x2: 344.382,
    y2: 486.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1692_139488",
    x1: 504.681,
    y1: 216.571,
    x2: 282.528,
    y2: 278.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower5);
export default __webpack_public_path__ + "static/media/flower5.fc3491ee5b86d8baaa91e225938c9000.svg";
export { ForwardRef as ReactComponent };